module.exports = __webpack_public_path__ + "static/media/matching-score-home.5cf80fa3.png";